import { colorPalette } from '@theme';

export const HAWKISH_COLOR = colorPalette.secondary.red;
export const DOVISH_COLOR = colorPalette.secondary.brightGreen;
